import { render, staticRenderFns } from "./DomainsTable.vue?vue&type=template&id=e217eb34&scoped=true"
import script from "./DomainsTable.vue?vue&type=script&lang=js"
export * from "./DomainsTable.vue?vue&type=script&lang=js"
import style0 from "./DomainsTable.vue?vue&type=style&index=0&id=e217eb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e217eb34",
  null
  
)

export default component.exports